import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
    FaArrowLeft,
    FaPlay,
    FaPause,
    FaBackward,
    FaForward,
    FaArrowRight,
} from "react-icons/fa";

import "./Step2Page.css";

// URL de l'API YouTube, utilisée pour charger le script de l'API
const youTubeScriptUrl = "https://www.youtube.com/iframe_api";

function Step2Page() {
    const { t, i18n } = useTranslation();

    // Existing video player states and refs
    const [playing, setPlaying] = useState(false);
    const iframeRef = useRef(null);
    const playerRef = useRef(null);
    const [isYoutubeApiLoaded, setIsYoutubeApiLoaded] = useState(false);

    // Map des IDs de vidéos YouTube par langue
    const videoMap = {
        fr: "WSFyB9vgRxE",
        en: "HCeoSIkWGT8",
        // Ajoutez d'autres langues et leurs IDs de vidéo si nécessaire
    };

    // --- YouTube Player Logic (Existing) ---
    useEffect(() => {
        if (!window.YT) {
            const tag = document.createElement("script");
            tag.src = youTubeScriptUrl;
            const firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubeIframeAPIReady = () => {
                setIsYoutubeApiLoaded(true);
            };
        } else {
            setIsYoutubeApiLoaded(true);
        }
    }, []);

    useEffect(() => {
        if (isYoutubeApiLoaded && iframeRef.current) {
            const videoId = videoMap[i18n.language] || videoMap.fr;

            if (playerRef.current) {
                playerRef.current.loadVideoById(videoId);
            } else {
                playerRef.current = new window.YT.Player(iframeRef.current, {
                    videoId: videoId,
                    events: {
                        onReady: onPlayerReady,
                        onStateChange: onPlayerStateChange,
                    },
                    playerVars: {
                        controls: 0,
                        modestbranding: 1,
                        rel: 0,
                        autoplay: 0,
                        showinfo: 0,
                        disablekb: 1,
                    },
                });
            }
            setPlaying(false);
        }

        return () => {
            if (playerRef.current) {
                playerRef.current.destroy();
                playerRef.current = null;
            }
        };
    }, [i18n.language, isYoutubeApiLoaded]);

    const onPlayerReady = (event) => {
        console.log("YouTube Player est prêt !");
    };

    const onPlayerStateChange = (event) => {
        if (event.data === window.YT.PlayerState.PLAYING) {
            setPlaying(true);
        } else {
            setPlaying(false);
        }
    };

    const handlePlayPause = () => {
        if (playerRef.current) {
            if (playing) {
                playerRef.current.pauseVideo();
            } else {
                playerRef.current.playVideo();
            }
        }
    };

    const handleRewind = () => {
        if (playerRef.current) {
            const currentTime = playerRef.current.getCurrentTime();
            playerRef.current.seekTo(currentTime - 10, true);
        }
    };

    const handleFastForward = () => {
        if (playerRef.current) {
            const currentTime = playerRef.current.getCurrentTime();
            playerRef.current.seekTo(currentTime + 10, true);
        }
    };

    return (
        <div className="step2-container">
            <div className="step2-content">
                <h1>{t("step2.title")}</h1>
                <p className="page-description">{t("step2.description")}</p>

                <div className="step2-video-player-area">
                    <div className="step2-player-wrapper">
                        <div id="step2-youtube-player" ref={iframeRef}></div>
                    </div>
                    <p className="step2-video-instruction">
                        {t("step2.click_to_play")}
                    </p>
                    <div className="video-controls">
                        <button
                            onClick={handleRewind}
                            className="video-control-button"
                        >
                            <FaBackward />
                        </button>
                        <button
                            onClick={handlePlayPause}
                            className="play-pause-button"
                        >
                            {playing ? <FaPause /> : <FaPlay />}
                        </button>
                        <button
                            onClick={handleFastForward}
                            className="video-control-button"
                        >
                            <FaForward />
                        </button>
                    </div>
                </div>

                <div className="next-button-container">
                    <div className="">
                        <p className="text1">{t("step2.titrevideo1")}</p>
                        <p className="text">{t("step2.textvideo1")}</p>
                        <p className="text1">{t("step2.titrevideo2")}</p>
                        <p className="text">{t("step2.textvideo2")}</p>
                        <p className="text1">{t("step2.titrevideo3")}</p>
                        <p className="text">{t("step2.textvideo3")}</p>
                        <p className="text1">{t("step2.titrevideo4")}</p>
                        <p className="text">{t("step2.textvideo4")}</p>
                        <p className="text1">{t("step2.titrevideo5")}</p>
                        <p className="text">{t("step2.textvideo5")}</p>
                    </div>
                    <div className="button-center-container1">
                        <Link to="/selection" className="inscription-button3">
                            <FaArrowLeft /> {t("step2.next_button1")}
                        </Link>
                        <Link to="/home" className="inscription-button3">
                            {t("step2.next_button")} <FaArrowRight />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Step2Page;
